import { PDFDocument } from 'pdf-lib';

export async function splitPdfToPages(pdfFile: File, pageIndices?: number[]): Promise<File[]> {
    const arrayBuffer = await pdfFile.arrayBuffer();
    const sourcePdf = await PDFDocument.load(arrayBuffer, { ignoreEncryption: true });
    const pageCount = sourcePdf.getPageCount();
    const pageFiles: File[] = [];
    const indicesToCopy = pageIndices ?? Array.from({ length: pageCount }, (_, index) => index);
    const baseName = pdfFile.name.replace(/\.pdf$/i, '');

    // Copy source pages into a staging document in one call to reduce repeated
    // source-document copy work for larger files.
    const stagingPdf = await PDFDocument.create();
    const stagedPages = await stagingPdf.copyPages(sourcePdf, indicesToCopy);
    stagedPages.forEach((page) => stagingPdf.addPage(page));

    for (let i = 0; i < stagedPages.length; i++) {
        const singlePagePdf = await PDFDocument.create();
        const [copiedPage] = await singlePagePdf.copyPages(stagingPdf, [i]);
        singlePagePdf.addPage(copiedPage);

        const pdfBytes = await singlePagePdf.save();
        pageFiles.push(
            new File([pdfBytes], `${baseName}-page-${indicesToCopy[i] + 1}.pdf`, {
                type: 'application/pdf',
            })
        );
    }

    return pageFiles;
}
